"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _joiBrowser = _interopRequireDefault(require("joi-browser"));

var _axios = _interopRequireDefault(require("axios"));

var _HttpService = _interopRequireDefault(require("../HttpService"));

var _AuthService = _interopRequireDefault(require("../AuthService"));

var _tenantHelper = require("../util/tenantHelper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var UserNotificationService = /*#__PURE__*/function () {
  function UserNotificationService() {
    _classCallCheck(this, UserNotificationService);
  }

  _createClass(UserNotificationService, null, [{
    key: "isEditUserNotificationsRequestValid",
    value: function isEditUserNotificationsRequestValid(request) {
      if (request === null || request === undefined) {
        return false;
      }

      var schema = _joiBrowser["default"].object().keys({
        readNotificationsTimestamps: _joiBrowser["default"].array().items(_joiBrowser["default"].number()),
        viewedNotificationsTimestamps: _joiBrowser["default"].array().items(_joiBrowser["default"].number())
      });

      return _joiBrowser["default"].validate(request, schema).error === null;
    }
  }, {
    key: "getPagedUserNotifications",
    value: function getPagedUserNotifications(auth0UserId, page, size) {
      if (!auth0UserId) {
        return Promise.reject(new Error('Missing User ID'));
      }

      return this.httpService.get("/".concat(auth0UserId, "/notifications?page=").concat(page, "&size=").concat(size));
    }
  }, {
    key: "getUserNotifications",
    value: function getUserNotifications(auth0UserId) {
      if (!auth0UserId) {
        return Promise.reject(new Error('Missing User ID'));
      }

      var http = _axios["default"].create({
        baseURL: "".concat(typeof window !== 'undefined' ? env.REACT_APP_NOTIFICATION_API : '', "/users"),
        headers: {
          'content-type': 'application/json',
          'X-Tenant': (0, _tenantHelper.getTenantFromUrl)(),
          authorization: "Bearer ".concat(_AuthService["default"].getToken())
        }
      });

      return new Promise(function (resolve) {
        http.get(encodeURI("/".concat(auth0UserId, "/notifications"))).then(function (response) {
          resolve(response);
        });
      });
    }
  }, {
    key: "updateUserNotifications",
    value: function updateUserNotifications(auth0UserId, request) {
      var _this = this;

      if (!auth0UserId) {
        return Promise.reject(new Error('Missing User ID'));
      }

      if (!UserNotificationService.isEditUserNotificationsRequestValid(request)) {
        return Promise.reject(new Error('Invalid edit user notifications request'));
      }

      return new Promise(function (resolve) {
        _this.httpService.patch("/".concat(auth0UserId, "/notifications"), request).then(function () {
          resolve(request);
        });
      });
    }
  }]);

  return UserNotificationService;
}();

exports["default"] = UserNotificationService;
UserNotificationService.httpService = new _HttpService["default"]({
  baseURL: "".concat(typeof window !== 'undefined' ? env.REACT_APP_NOTIFICATION_API : '', "/users")
});